import {
	DefinedRangeType,
	RangeCalendar,
} from "components/Shared/MultiRangeCalendar"
import {
	CUSTOM_RANGES_ID,
	LAST_30_DAYS_PRESET_ID,
	LAST_90_DAYS_PRESET_ID,
	MOBILE_YEAR_PRESET_ID,
	MONTH_PRESET_ID,
	QUARTER_PRESET_ID,
	YEAR_PRESET_ID,
} from "components/Shared/MultiRangeCalendar/constants"
import {
	calculateRangeLast30Days,
	calculateRangeLast90Days,
	calculateStartOfMonth,
	calculateStartOfQuarter,
	getCalendarLabel,
	getEndDateWithData,
} from "./utils"
import { addYears, getYear } from "date-fns"
import { getToday } from "components/Shared/MultiRangeCalendar/CalendarPresets/utils/utils"
import { COLOR_PALETTE } from "colors"

const RANGE_COLORS = {
	color: COLOR_PALETTE.DARK_PURPLE_600,
	secondaryColor: COLOR_PALETTE.PURPLE_100,
}

export const DEFAULT_CROSS_SELLING_CALENDAR_TITLE = "phronesis.calendar.title"
const CURRENT_DATE_LABEL =
	"phronesis.transactional.application.commercial.benchmark.current.date"

export const CUSTOM_RANGE_CROSS_SELLING: RangeCalendar[] = [
	{
		id: "currentDate",
		startDate: null,
		endDate: null,
		label: CURRENT_DATE_LABEL,
		...RANGE_COLORS,
	},
]

export const YEAR_RANGE: RangeCalendar[] = [
	{
		id: "currentDate",
		startDate: new Date(getYear(getToday()), 0, 1),
		endDate: getEndDateWithData(),
		label: CURRENT_DATE_LABEL,
		...RANGE_COLORS,
	},
]

export const MOVING_YEAR_RANGE: RangeCalendar[] = [
	{
		id: "currentDate",
		startDate: addYears(getEndDateWithData(), -1),
		endDate: getEndDateWithData(),
		label: CURRENT_DATE_LABEL,
		...RANGE_COLORS,
	},
]

export const QUARTER_RANGE: RangeCalendar[] = [
	{
		id: "currentDate",
		startDate: calculateStartOfQuarter(),
		endDate: getEndDateWithData(),
		label: CURRENT_DATE_LABEL,
		...RANGE_COLORS,
	},
]

export const MONTH_RANGE: RangeCalendar[] = [
	{
		id: "currentDate",
		startDate: calculateStartOfMonth(),
		endDate: getEndDateWithData(),
		label: CURRENT_DATE_LABEL,
		...RANGE_COLORS,
	},
]

export const presetLast90day = (): RangeCalendar[] => {
	const [startDate, endDate] = calculateRangeLast90Days()

	return [
		{
			id: "currentDate",
			startDate,
			endDate,
			label: CURRENT_DATE_LABEL,
			...RANGE_COLORS,
		},
	]
}

export const presetLast30day = (): RangeCalendar[] => {
	const [startDate, endDate] = calculateRangeLast30Days()

	return [
		{
			id: "currentDate",
			startDate,
			endDate,
			label: CURRENT_DATE_LABEL,
			...RANGE_COLORS,
		},
	]
}

export const CUSTOM_RANGES_PRESET: DefinedRangeType = {
	id: CUSTOM_RANGES_ID,
	label: getCalendarLabel("customrange"),
	isSelected: false,
	fn: () => CUSTOM_RANGE_CROSS_SELLING,
}
export const YEAR_RANGE_PRESET: DefinedRangeType = {
	id: YEAR_PRESET_ID,
	label: "phronesis.calendar.title",
	isSelected: false,
	fn: () => YEAR_RANGE,
}
export const MOVING_YEAR_RANGE_PRESET: DefinedRangeType = {
	id: MOBILE_YEAR_PRESET_ID,
	label: getCalendarLabel("moving.year"),
	isSelected: false,
	fn: () => MOVING_YEAR_RANGE,
}

export const QUARTER_RANGE_PRESET: DefinedRangeType = {
	id: QUARTER_PRESET_ID,
	label: getCalendarLabel("quarter"),
	isSelected: false,
	fn: () => QUARTER_RANGE,
}

export const MONTH_RANGE_PRESET: DefinedRangeType = {
	id: MONTH_PRESET_ID,
	label: getCalendarLabel("month"),
	isSelected: false,
	fn: () => MONTH_RANGE,
}

export const LAST_90_DAYS_PRESET: DefinedRangeType = {
	id: LAST_90_DAYS_PRESET_ID,
	label: getCalendarLabel("last_90_days"),
	isSelected: false,
	fn: presetLast90day,
}

export const LAST_30_DAYS_PRESET: DefinedRangeType = {
	id: LAST_30_DAYS_PRESET_ID,
	label: getCalendarLabel("last_30_days"),
	isSelected: false,
	fn: presetLast30day,
}
